module.exports = __webpack_public_path__ + "static/media/CHAT_CAREER.efe2a0a4.png";